export default __webpack_public_path__ + "static/media/homebanner-2.e027fc45.jpg";